<template>

    <v-card @click="$emit('click', item)">
      <v-card-text>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 md8 lg9>
            <div class=" mt-4">
              <provider-stats :provider="item"></provider-stats>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

</template>

<script>
    import ProviderStats from './ProviderStats'
    import QuotationRequestForm from './QuotationRequestForm'

    export default{
        props: ['item'],
        components: { ProviderStats, QuotationRequestForm },
        data(){
            return {
                showQuotationForm: false
            }
        },
        methods:{
            onChange(val){
                this.showQuotationForm = val
            }
        }
    }


</script>